<template>
	<div class="payment-transactions">
		<div class="payment-transactions__title">
			<p>
				<i class="fa-regular fa-handshake"></i>
				{{
					$store.getters.getRightText(
						'dossierdetailTableTitlePaymentTransactionsPayments'
					)
				}}<span> (2)</span>
			</p>
		</div>
		<div class="payment-transactions__table table-container">
			<table
				class="table is-fullwidth is-striped"
				aria-describedby="Betalingsmutaties-table"
			>
				<thead>
					<tr>
						<th></th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsCaseNumber'
								)
							}}
						</th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsReference'
								)
							}}
						</th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsAmount'
								)
							}}
						</th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsTransactionDate'
								)
							}}
						</th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsDescription'
								)
							}}
						</th>
						<th>
							{{
								$store.getters.getRightText(
									'dossierdetailTableHeadPaymentTransactionsStatus'
								)
							}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(paymentTransaction, index) in paymentTransactionsData"
						:key="index"
					>
						<td>{{ index + 1 }}</td>
						<td>{{ paymentTransaction.dossiernummer }}</td>
						<td>{{ paymentTransaction.referentienr }}</td>
						<td>{{ toEuro(paymentTransaction.bedrag, true) }}</td>
						<td>
							{{ toDateStrFullMnth(paymentTransaction.transactie_datum) }}
						</td>
						<td>{{ paymentTransaction.omschrijving }}</td>
						<td>{{ paymentTransaction.status }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import mixin from '../../mixin';

export default {
	mixins: [mixin],
	props: {
		idFromUrl: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			paymentTransactionsData: [],
		};
	},
	async mounted() {
		await this.fetchData(this.idFromUrl);
	},
	methods: {
		async fetchData(idFromURL) {
			try {
				// console.log('paymentTransactionsData Received ID:', idFromURL);
				const response = await axios.get(
					`/api/dossiers/${idFromURL}/betalingsmutaties`
				);
				if (response ?? response.data) {
					this.paymentTransactionsData = response.data;
				} else {
					console.error('Invalid data received:', response);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		},
	},
};
</script>
